class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.upsellATC = this.querySelectorAll('[btn-upsell-atc]');
    this.crosssellSlider = this.querySelector('[data-upsell-cart-slider] slider-component')
    let _this = this;
    this.upsellATC.forEach(function(btn){
      btn.addEventListener('click',function(evt){
        _this.addUpselltoCart(evt);
      })
    })

    if(document.querySelector('.drawer.is-empty') == null){
     
      setTimeout(() => { // remove free products on load
       if(document.querySelector('[data-only-free-product]') != null){ // remove alone free product from cart
          document.querySelector('[data-only-free-product] cart-remove-button').click();
        }
        if(document.querySelectorAll('[data-remove-custom-plan]').length){ // remove free product from cart if subscription is removed
          document.querySelectorAll('[data-remove-custom-plan]').forEach(function(ele){
            ele.querySelector('cart-remove-button').click();
          })
        }
      },200);
      
      if(this.crosssellSlider != null){
        let activeIndex = this.crosssellSlider.swiper.activeIndex;
        this.crosssellSlider.swiper.on('slideChange', function() {
          // console.log(this.activeIndex, this.realIndex + 1); 
          if(this.activeIndex > activeIndex){
            // console.log('next',_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-next"]'));
            _this.CrosssellPagination(_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-next"]'));
          } else{
            // console.log('prev',_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-prev"]'));
            _this.CrosssellPagination(_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-prev"]'));
          }
          activeIndex = this.activeIndex;
        });
      }
    }
    
  }

  CrosssellPagination(nav){ // crossell section pagination
    document.querySelectorAll('[data-upsell-pagination]').forEach((ele) => ele.classList.remove('disabled')); // remove disabled from all and add to applicable ones
    let btn = nav.dataset.upsellPagination;
    nav.closest('[data-upsell-cart-slider]').querySelector(btn).click();
    if(nav.closest('[data-upsell-cart-slider]').querySelector(btn).getAttribute('aria-disabled') == 'true'){
      nav.classList.add('disabled');
    } else{
      nav.classList.remove('disabled');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      console.log('innnnifffffffffff')
      $.getJSON('/cart.js', function(cart){
        function setCookie(name, value, days) {
          var d = new Date;
          d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
          document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }

        function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }

        var totldisc = 0;
        var distitle = '';
        $(cart.items).each(function(i,e){
          if(e.line_level_discount_allocations.length && e.line_level_discount_allocations[0].discount_application.type != "discount_code"){
            totldisc += parseInt(e.discounts[0].amount);
            distitle = e.discounts[0].title;
          }
        });
        if(totldisc > 0){
          if(!getCookie('discountshown') && $('cart-drawer').hasClass('active')){
            $('.free-gift-added-popover_overlay .code').html(distitle);
            var prichtml = Shopify.formatMoney(totldisc);
            $('.free-gift-added-popover_overlay [data-totaldisprice]').html(prichtml.replace('.00',''));
            $('.free-gift-added-popover_overlay').show();
            setCookie('discountshown',true,30);
            setTimeout(function(){
              $('.free-gift-added-popover_overlay').hide();
            },3000);  
          }
          
        }else{
          setCookie('discountshown',false,-1);
        }
      });

      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    await this.checkByobBundlesInCart();
  }

  checkByobBundlesInCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(cart => {
        // Check if any BYOB bundle exists
        const hasByobBundle = cart.items.some(item => item.properties && item.properties._byob_products);
        
        // Update the `order_type` attribute
        const attributes = hasByobBundle
          ? { order_type: 'byob' }
          : { order_type: '' };
          
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes }),
        });
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated after product removal:', data);
      })
      .catch(error => {
        console.error('Error handling product removal:', error);
      }).finally(() => {
        setTimeout(() => {
          const button = document.querySelector(".cartDisable");
          if (button) button.removeAttribute("disabled");
          console.log("finally logic");
        }, 1000);
      });

      console.log("end");
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  onCartUpdate() {
    console.log('hello cart u[date');
    fetch(`${routes.cart_url}`)
      .then((response) => response.text())
      .then((response) => {
        // console.log('responsee',response);
        const html = new DOMParser().parseFromString(response, 'text/html');
        const sourceQty = html.querySelector('#CartDrawer-Form');
        const AOVBar = html.querySelector('.aov-bar-section');
        // console.log('sourceQty',sourceQty);
        if(AOVBar != null) this.querySelector('.aov-bar-section').innerHTML = AOVBar.innerHTML;
        if(this.querySelector('#CartDrawer-Form') != null) this.querySelector('#CartDrawer-Form').innerHTML = sourceQty.innerHTML;
        if(this.querySelector('#cart-order-summary') != null) this.querySelector('#cart-order-summary').innerHTML = html.querySelector('#cart-order-summary').innerHTML;
        if(this.querySelector('#cart-drawer__footer') != null) this.querySelector('#cart-drawer__footer').innerHTML = html.querySelector('#cart-drawer__footer').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  addTocartForm(form,cart,submitButton,RandomNumber){
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    console.log(form,cart,submitButton,RandomNumber)
    const formData = new FormData(form);
    for (const value of formData) {
      console.log('78946',value);   
    } 

    var __this = this;

    if($(submitButton).attr("free_gift_id") != ''){
      var free_gift_id = parseInt($(submitButton).attr("free_gift_id"));
      // var randomId = parseInt($(submitButton).attr("variant-random-id"));
      var randomId = Math.random().toString(36).substring(2, 12);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { 
          id: free_gift_id, 
          quantity: 1,
          properties: {
            '_personalize': 'sub',
            '_type': 'free_gift',
            '_bundleid': randomId
          }
        },
        dataType: 'json',
        async: false,
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          console.log('response',response)
          //alert(response.description);
        },
        success: function() {
          formData.append('properties[_freegift]','Free Gift');
          formData.append('properties[_personalize]','main');
          formData.append('properties[_bundleid]',randomId);
          // $(__this).find('form').prepend(`
          // <input type="hidden" class="sub-product_meta-property" name="properties[_freegift]" value="Free Gift">
          // <input type="hidden" class="sub-product_meta-property" name="properties[_personalize]" value="main">
          // <input type="hidden" class="sub-product_meta-property" name="properties[_bundleid]" value="${randomId}">`);
          console.log('success');
          $(".coupon-confirm-popup").fadeIn(); // Show element
          setTimeout(function () {
            $(".coupon-confirm-popup").fadeOut(); // Hide after 6 sec
          }, 5000);
        }
      });
    }    
    
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if(RandomNumber != 0){
        formData.append('properties[_bundle_number]',RandomNumber);
      }
     
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.log('111')
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          console.log('2222')
          if(submitButton != null){
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
          }
          console.log('333')
          this.error = true;
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
console.log('4444')
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
        console.log('6666')
          cart.renderContents(response);
        console.log('5555')
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(submitButton != null) submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!this.error && submitButton != null) submitButton.removeAttribute('aria-disabled');
        if(submitButton != null) submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  addAddonItem(addonBox,RandomNumber){

    let cart  = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let submitButton = addonBox.closest('[data-atc-container]').querySelector('button[name="add"]');

    // console.log('addonBox',addonBox);

    const upsellForm = document.createElement("form");
    const idInput = document.createElement("input");
    idInput.name = 'id';
    idInput.value = addonBox.querySelector('input').value;
    const qtyInput = document.createElement("input");
    qtyInput.name = 'quantity';
    qtyInput.value = 1;
    upsellForm.appendChild(idInput);
    upsellForm.appendChild(qtyInput);

    this.addTocartForm(upsellForm,cart,submitButton,RandomNumber)
  }

  
  renderContents(parsedState) {
    var _this = this;
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // open cart
      if(parsedState.properties['_sections_type'] != "sale-collection"){
        this.open();
      }
    });

    setTimeout(() =>{
      if(document.querySelector('.drawer.is-empty') == null){
        let upsellATC = document.querySelector('cart-drawer').querySelectorAll('[btn-upsell-atc]')
        upsellATC.forEach(function(btn){
          btn.addEventListener('click',function(evt){
            document.querySelector('cart-drawer').addUpselltoCart(evt);
          })
        },50)
      }
    })
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  addUpselltoCart(evt){
    evt.preventDefault();
    var _this = this;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = evt.currentTarget;
    this.upsellType = this.submitButton.dataset.upsellType;
    this.qtyInput = evt.target.closest('[data-upsell-container]').querySelector('input[name="quantity"]');
    this.idInput = evt.target.closest('[data-upsell-container]').querySelector('input[name="id"]');
    this.sellingPlanInp = evt.target.closest('[data-upsell-container]').querySelector('input[name="selling_plan"]');
    this.lineInp = evt.target.closest('[data-upsell-container]').querySelector('input[name="line"]');
    this.propInp = evt.target.closest('[data-upsell-container]').querySelectorAll('input[name^="properties"]');
    
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const upsellForm = document.createElement("form");
    
    const qtyInput = document.createElement("input");
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = this.qtyInput.value;
    if(this.upsellType == 'subscription upsell'){
      // nothing
    } else if(this.upsellType == 'subscription crosssell'){
      console.log('1111')
      const sellingPLanInp = document.createElement("input");
      sellingPLanInp.type = 'hidden';
      sellingPLanInp.name = 'selling_plan';
      sellingPLanInp.value = this.sellingPlanInp.value;
      upsellForm.appendChild(sellingPLanInp);
      const idInput = document.createElement("input");
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = this.idInput.value;
      upsellForm.appendChild(idInput);
      // add bundle id for custom diet products
      if(this.propInp.length != 0){
        let propInput;
        this.propInp.forEach(function(inp){
          propInput = document.createElement("input");
          propInput.type = 'hidden';
          propInput.name = inp.name;
          propInput.value = inp.value;
          upsellForm.appendChild(propInput);
        })
      }
    } else if(this.upsellType == 'replace crosssell'){
      console.log('22222')
      const lineInput = document.createElement("input");
      lineInput.type = 'hidden';
      lineInput.name = 'line';
      lineInput.value = this.lineInp.value;
      upsellForm.appendChild(lineInput);
      const idInput = document.createElement("input");
      idInput.type = 'hidden';
      idInput.name = 'id';
      console.log(this.idInput.value,'ddddddd')
      idInput.value = this.idInput.value;
      console.log(idInput)
      upsellForm.appendChild(idInput);
      if(this.propInp.length != 0){
        let propInput;
        this.propInp.forEach(function(inp){
          propInput = document.createElement("input");
          propInput.type = 'hidden';
          propInput.name = inp.name;
          propInput.value = inp.value;
          upsellForm.appendChild(propInput);
        })
      }
    } else{
      console.log('33333')
      const idInput = document.createElement("input");
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = this.idInput.value;
      upsellForm.appendChild(idInput);
    }
    upsellForm.appendChild(qtyInput);
    if(this.upsellType == 'subscription upsell'){
      const cartItems = this.cart.querySelector('cart-drawer-items');
      let propObj = { };
      if(this.propInp.length != 0){
        this.propInp.forEach(function(inp){
          propObj[inp.name.split('properties[')[1].split(']')[0]] = inp.value;
        })
      }
      cartItems.updateQuantity(this.lineInp.value,this.qtyInput.value,this.sellingPlanInp.value,document.activeElement.getAttribute('name'),propObj)
    } else if(this.upsellType == 'subscription crosssell' || this.upsellType == 'replace crosssell'){
      this.replaceCartProduct(this.lineInp.value,0,upsellForm,this.cart,this.submitButton);
    } else{
      this.addTocartForm(upsellForm,this.cart,this.submitButton,0);
    }
  }
  replaceCartProduct(line,quantity,form,cart,submitButton){    
    var __this = this;
    if($(submitButton).attr("remove_free_gift_id") != '' && $(submitButton).attr("remove_free_gift_id") != undefined){
      var remove_free_gift_id = parseInt($(submitButton).attr("remove_free_gift_id"));
      var itemindex = $(this).find(`.cart-item[data-itemvarid="${remove_free_gift_id}"]`).attr('data-line-id');
      var quantity = parseInt(quantity);
       $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
              line: itemindex,
              quantity: 0
          },
          async: false,
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            var response = $.parseJSON(jqXHR.responseText);
            //alert(response.description);
          },
          success: function () {
            console.log('success');
          },
       }); 
    }    
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`,  { ...fetchConfig(), ...{ body } } )
      .then((response) => response.json())
      .then((response) => {

        if (response.status) {
          if(submitButton != null){
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            this.error = true;
          }
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart'});
          this.error = false;
          this.addTocartForm(form,cart,submitButton,0);  
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(submitButton != null) submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!this.error && submitButton != null) submitButton.removeAttribute('aria-disabled');
        if(submitButton != null) submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

if(document.querySelector('[data-close-drawer],[data-cart-discount-popup]') != null){
  document.querySelector('[data-close-drawer],[data-cart-discount-popup]').addEventListener('click',function(e){
    e.preventDefault();
    if(!e.target.matches('[data-cart-discount-popup]') && !e.target.matches('[data-close-drawer]')) return;
    if(this.classList.contains('drawer')){
      this.classList.remove('active');
    } else{
      this.closest('.drawer').classList.remove('active');
    }
  })
}


customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);